module.exports = __webpack_public_path__ + "static/media/wojciech-brzozka.c4148ffd.jpg";